<div class="card-wrap {{theme}}" [ngClass]="{'prevent-click': noRedirect}">
  <div class="content" (click)="goToFundraiser($event)">
    <div class="image">
      <img loading="lazy" [attr.data-src]="fundraiser?.leaderboard?.cdn_path || fundraiser?.theater?.cdn_path || fundraiser?.widget?.cdn_path || util.defaultImg" [default]="util.defaultImg" alt="" />
      <div *ngIf="fundraiser?.taxexempted || fundraiser?.beneficiary?.tax_benefit" class="tax-nudge">TAX Benefit</div>
    </div>
    <div class="text">
      <div class="title">{{fundraiser?.title}}</div>
      <!-- <div class="hr-line"></div>
      <div class="fund-details">
        <div class="require">
          <div *ngIf="fundraiser?.amount_requested" class="label">Funds Required</div>
          <div *ngIf="fundraiser?.amount_requested" class="amount">
            <app-currency-icon [currency]="currency"></app-currency-icon>{{fundraiser?.amount_requested | inrFormat:currency}}
          </div>
        </div>
      </div> -->
      <!-- <div class="progress-bar"><div class="prog" [style]="'width: ' + ((fundraiser?.raised?.raised / fundraiser?.amount_requested) * 100) + '%'"></div></div> -->
      <div class="bottom">
        <!-- <div class="supporters">
          <div class="logo"><img loading="lazy" [attr.data-src]="'/assets/images/supporters.png'" alt="" /></div>
          <div class="t">{{fundraiser?.raised?.backers | abbreviateNumber}} people donated</div>
        </div>
        <div *ngIf="!isFundraiserEnded" class="middle"></div> -->
        <div *ngIf="!isFundraiserEnded" class="donate-btn">
          <button mat-button>Contribute</button>
        </div>
      </div>
    </div>
  </div>
</div>